module.exports = __webpack_public_path__ + "images/harley_smallf4f8f21fade3061589e82cd0ab5e5b1c.png";